/* countdown-timer.js
 * Visar dagar + timmar när det återstår ≥ 1 dag.
 * Visar timmar + minuter först när dagar = 0.
 * Minuter visas alltså bara när inga hela dagar återstår.
 * Formatering:
 *   - Komma mellan värden
 *   - Punkt efter sista värdet (alltid)
 */

(function () {
  'use strict';

  // Kör när DOM är redo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var timers = document.querySelectorAll('.countdown-timer');
    if (!timers.length) return;

    timers.forEach(function (el) {
      // Rensa ev. tidigare intervall
      if (el.__ctInterval) {
        clearInterval(el.__ctInterval);
        el.__ctInterval = null;
      }

      var start = parseInt(el.dataset.start, 10) || 0;
      var end   = parseInt(el.dataset.end, 10)   || 0;
      if (!end) return;

      // Första render
      tick(el, start, end);

      // Uppdatera var 30:e sekund (räcker för erbjudanden)
      el.__ctInterval = setInterval(function () {
        tick(el, start, end);
      }, 30000);
    });
  }

  function tick(el, start, end) {
    try {
      var now = Math.floor(Date.now() / 1000);
      var diff = Math.max(0, end - now);
      render(el, diff);

      if (diff <= 0 && el.__ctInterval) {
        clearInterval(el.__ctInterval);
        el.__ctInterval = null;
      }
    } catch (err) {
      console.error('countdown-timer error:', err);
    }
  }

  function render(el, diffSeconds) {
    var daySing = el.dataset.labelDaySingular     || 'day';
    var dayPlu  = el.dataset.labelDayPlural       || 'days';
    var hrSing  = el.dataset.labelHourSingular    || 'hour';
    var hrPlu   = el.dataset.labelHourPlural      || 'hours';
    var minSing = el.dataset.labelMinuteSingular  || 'minute';
    var minPlu  = el.dataset.labelMinutePlural    || 'minutes';

    var days    = Math.floor(diffSeconds / 86400);
    var rem     = diffSeconds % 86400;
    var hours   = Math.floor(rem / 3600);
    rem         = rem % 3600;
    var minutes = Math.floor(rem / 60);

    var valueEl = el.querySelector('.timer-value');
    if (!valueEl) return;

    var text;
    if (diffSeconds <= 0) {
      text = '0 ' + pluralize(0, hrSing, hrPlu) + '.';
      el.setAttribute('data-days-zero', 'true');
    } else if (days > 0) {
      text =
        days + ' ' + pluralize(days, daySing, dayPlu) + ', ' +
        hours + ' ' + pluralize(hours, hrSing, hrPlu) + '.';
      el.setAttribute('data-days-zero', 'false');
    } else {
      text =
        hours + ' ' + pluralize(hours, hrSing, hrPlu) + ', ' +
        minutes + ' ' + pluralize(minutes, minSing, minPlu) + '.';
      el.setAttribute('data-days-zero', 'true');
    }

    valueEl.textContent = text;
  }

  function pluralize(n, singular, plural) {
    return n === 1 ? singular : plural;
  }
})();